import React from 'react';
import PropTypes from 'prop-types';
import Ellipsis from 'ellipsis.js';

export default class Truncator extends React.Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.configure();
  }

  componentDidMount() {
    if (this.ellipsis && this.truncateContainer) {
      this.ellipsis.add(this.truncateContainer);
    }
  }

  // Turn off react because we mutate with Ellipsis
  shouldComponentUpdate() {
    return false;
  }

  configure() {
    this.ellipsis = Ellipsis({
      ellipsis: ['…', ...(new Array(15).fill(' '))].join(''),
      debounce: 500,
      responsive: true,
      className: false,
      lines: 2,
      break_word: true,
    });
  }

  render() {
    return <span ref={node => (this.truncateContainer = node)}>{this.props.summary}</span>;
  }
}

Truncator.propTypes = {
  summary: PropTypes.string.isRequired,
};
